import {matchRoutes} from 'react-router-config';

import {generate} from '../routes.js';
import {getLandingRouteNameForUser, isUserFreelance} from '../../shared/services/userService.js';
import routes from '../routes.js';

export default function (user, freelance = null, redirectTo = null) {
  //le windows.location est volontaire pour update le state de l'user loggé
  if (!user.id) {
    window.location = generate({name: 'confirm-registration'});
    return
  }

  if (user.complete) {
    const matches = matchRoutes(routes, redirectTo);
    const exactMatches = matches.filter(match => match.match.isExact);

    if (
      null !== redirectTo && exactMatches.length
      && exactMatches[0].match.path !== '/'
    ) {
      window.location = redirectTo;
      return
    }

    window.location = generate({
      name: getLandingRouteNameForUser(user)
    });

    return;
  }

  if (isUserFreelance(user)) {
    window.location = generate({name: 'create-freelance'});
    return
  }

  window.location = generate({name: 'homepage'});
  return
}
